import Raven from 'raven-js';

const LIBRARY_NAME = 'react-rhumb';

type RavenCaptureOptions = NonNullable<
  Parameters<typeof Raven.captureException>[1]
>;

export function captureException(
  error: Error,
  options: RavenCaptureOptions = {}
): void {
  Raven.captureException(error, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
}

export function captureMessage(
  message: string,
  options: NonNullable<Parameters<typeof Raven.captureMessage>[1]> = {}
): void {
  Raven.captureMessage(message, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
}

export function capturePageEvent(
  name: string,
  options: NonNullable<Parameters<typeof Raven.capturePageEvent>[1]> = {}
): void {
  Raven.capturePageEvent(name, {
    ...options,
    tags: { ...options.tags, library_name: LIBRARY_NAME },
  });
}
